import { render } from "./ClientUser.vue?vue&type=template&id=3de49dd7"
import script from "./ClientUser.vue?vue&type=script&lang=js"
export * from "./ClientUser.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__